/* =========================================================================
   NOAH'S — product card interactions
   - colour swatch  : selects the colour + updates the product image (no add)
   - size button    : adds the (selected colour + size) variant to the cart
   - quick-add icon : reveals the size panel (or adds directly if no sizes)
   - image gallery  : swipe / arrows / dots
   - cart drawer    : change a line item's size without removing it
   ========================================================================= */
(function () {
  'use strict';

  var rootPath = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';

  function cartDrawer() { return document.querySelector('cart-drawer'); }
  function drawerSections() {
    var d = cartDrawer();
    return (d && typeof d.getSectionsToRender === 'function')
      ? d.getSectionsToRender().map(function (s) { return s.id; })
      : [];
  }
  function refreshDrawer(state) {
    // Prefer the custom cart drawer (snippets/cart-drawer.liquid): open + live-refresh it.
    if (typeof window.openCustomCartDrawer === 'function') {
      window.openCustomCartDrawer();
      if (state && typeof window.updateHeaderCartCount === 'function') {
        window.updateHeaderCartCount(state.item_count);
      }
      return;
    }
    var d = cartDrawer();
    if (d && typeof d.renderContents === 'function') {
      d.renderContents(state);
      d.classList.remove('is-empty');
      var items = d.querySelector('cart-drawer-items');
      if (items) items.classList.remove('is-empty');
    } else {
      window.location = rootPath + 'cart';
    }
  }

  /* ---------- product card helpers ---------- */
  function cardVariants(card) {
    var el = card.querySelector('.cstm-pc-variants');
    if (!el) return [];
    try { return JSON.parse(el.textContent); } catch (e) { return []; }
  }
  function selectedColor(card) {
    var active = card.querySelector('.cstm-product-card__color-link.is-active');
    return active ? active.getAttribute('data-color') : null;
  }
  /* ---------- image gallery ---------- */
  function galleryDots(card) {
    var g = card.querySelector('.cstm-pc-gallery');
    var dots = card.querySelectorAll('.cstm-pc-dot');
    if (!g || !dots.length) return;
    var idx = Math.round(g.scrollLeft / g.clientWidth);
    dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
  }
  function galleryGo(card, dir) {
    var g = card.querySelector('.cstm-pc-gallery');
    if (!g) return;
    var w = g.clientWidth;
    var max = g.scrollWidth - w;
    var target = g.scrollLeft + dir * w;
    if (target > max + 2) target = 0;        // past the last image -> loop to first
    else if (target < -2) target = max;      // before the first -> loop to last
    g.scrollTo({ left: target, behavior: 'smooth' });
  }
  function galleryToImage(card, imageId, fallbackSrc) {
    var g = card.querySelector('.cstm-pc-gallery');
    if (g && imageId) {
      var slide = g.querySelector('.cstm-pc-slide[data-image-id="' + imageId + '"]');
      if (slide) { g.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' }); galleryDots(card); return; }
    }
    if (fallbackSrc) {
      var img = card.querySelector('.cstm-pc-slide .cstm-product-card__image');
      if (img) { img.src = fallbackSrc; img.srcset = ''; if (g) g.scrollTo({ left: 0, behavior: 'smooth' }); }
    }
  }
  // load a deferred gallery image
  function loadLazy(img) {
    if (img.getAttribute('data-src')) img.src = img.getAttribute('data-src');
    if (img.getAttribute('data-srcset')) img.srcset = img.getAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-srcset');
    img.classList.remove('cstm-pc-lazy');
  }
  // only load gallery images when they're swiped/scrolled into the slider's view
  function lazyObserve(g) {
    var lazies = g.querySelectorAll('img.cstm-pc-lazy[data-src]');
    if (!lazies.length) return;
    if (!('IntersectionObserver' in window)) { lazies.forEach(loadLazy); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { loadLazy(en.target); io.unobserve(en.target); }
      });
    }, { root: g, rootMargin: '0px 300px', threshold: 0.01 });
    lazies.forEach(function (img) { io.observe(img); });
  }

  function initGalleries() {
    document.querySelectorAll('.cstm-pc-gallery').forEach(function (g) {
      if (g.dataset.cstmInit) return;
      g.dataset.cstmInit = '1';
      lazyObserve(g);
      var card = g.closest('.cstm-product-card');
      var t;
      g.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { galleryDots(card); }, 60);
      }, { passive: true });
    });
  }

  /* ---------- pick the variant to add (selected colour + selected size) ---------- */
  function pickAddVariant(card) {
    var variants = cardVariants(card);
    var color = selectedColor(card);
    function colorOk(v) { return v.color == null || color == null || String(v.color) === String(color); }

    var selSize = card.querySelector('.cstm-product-card__size-link.is-selected');
    var size = selSize ? selSize.getAttribute('data-size') : null;

    if (size != null) {
      var m = variants.filter(function (v) { return colorOk(v) && String(v.size) === String(size); });
      return m.filter(function (v) { return v.available; })[0] || m[0] || null;
    }

    // no size chosen yet -> first available variant for the colour, and reflect it in the UI
    var pool = variants.filter(colorOk);
    var chosen = pool.filter(function (v) { return v.available; })[0] || pool[0] || null;
    if (chosen && chosen.size != null) {
      var btns = card.querySelectorAll('.cstm-product-card__size-link');
      btns.forEach(function (b) {
        b.classList.toggle('is-selected', b.getAttribute('data-size') === String(chosen.size));
      });
    }
    return chosen;
  }

  /* ---------- resolve the variant for the current colour+size (no side effects) ---------- */
  function resolveCardVariant(card) {
    var variants = cardVariants(card);
    if (!variants.length) return null;
    var color = selectedColor(card);
    function colorOk(v) { return v.color == null || color == null || String(v.color) === String(color); }
    var selSize = card.querySelector('.cstm-product-card__size-link.is-selected');
    var size = selSize ? selSize.getAttribute('data-size') : null;
    if (size != null) {
      var m = variants.filter(function (v) { return colorOk(v) && String(v.size) === String(size); });
      return m.filter(function (v) { return v.available; })[0] || m[0] || null;
    }
    var pool = variants.filter(colorOk);
    return pool.filter(function (v) { return v.available; })[0] || pool[0] || null;
  }

  /* ---------- update the card's shown price to match the chosen variant ---------- */
  function updateCardPrice(card) {
    var v = resolveCardVariant(card);
    if (!v || v.price == null) return;
    var curEl = card.querySelector('.cstm-product-card__price-current');
    var oldEl = card.querySelector('.cstm-product-card__price-old');
    if (curEl) curEl.textContent = v.price;
    if (oldEl) {
      if (v.onSale && v.compare) { oldEl.textContent = v.compare; oldEl.style.display = ''; }
      else { oldEl.style.display = 'none'; }
    }
  }

  /* ---------- colour selection ---------- */
  function selectColor(btn) {
    var card = btn.closest('.cstm-product-card');
    if (!card) return;
    card.querySelectorAll('.cstm-product-card__color-link').forEach(function (b) { b.classList.remove('is-active'); });
    btn.classList.add('is-active');
    galleryToImage(card, btn.getAttribute('data-image-id'), btn.getAttribute('data-variant-image'));
    updateCardPrice(card);
  }

  /* ---------- add a variant to the cart ---------- */
  function addVariant(variantId, qty, sourceEl) {
    if (sourceEl) sourceEl.classList.add('is-loading');
    return fetch(rootPath + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: qty || 1 }],
        sections: drawerSections(),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (sourceEl) sourceEl.classList.remove('is-loading');
        if (state && state.status) {
          if (sourceEl) {
            sourceEl.classList.add('is-error');
            setTimeout(function () { sourceEl.classList.remove('is-error'); }, 1600);
          }
          return;
        }
        refreshDrawer(state);
      })
      .catch(function () { if (sourceEl) sourceEl.classList.remove('is-loading'); });
  }

  /* ---------- delegated clicks ---------- */
  document.addEventListener('click', function (e) {
    /* colour swatch -> select + image (never adds) */
    var color = e.target.closest('.cstm-product-card__color-link');
    if (color) {
      e.preventDefault();
      selectColor(color);
      return;
    }

    /* gallery arrows */
    var nav = e.target.closest('.cstm-pc-nav');
    if (nav) {
      e.preventDefault();
      var c = nav.closest('.cstm-product-card');
      if (c) galleryGo(c, nav.classList.contains('cstm-pc-prev') ? -1 : 1);
      return;
    }

    /* size button -> select it (white bg), do NOT add yet */
    var sizeBtn = e.target.closest('.cstm-product-card__size-link');
    if (sizeBtn) {
      e.preventDefault();
      var scard = sizeBtn.closest('.cstm-product-card');
      if (scard) {
        scard.querySelectorAll('.cstm-product-card__size-link').forEach(function (b) { b.classList.remove('is-selected'); });
        sizeBtn.classList.add('is-selected');
        updateCardPrice(scard);
      }
      return;
    }

    /* Quick Add (cart icon) -> reveal the size panel; add directly when there are no sizes */
    var quickBtn = e.target.closest('.cstm-pc-quickadd');
    if (quickBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (quickBtn.classList.contains('is-loading')) return;
      var qcard = quickBtn.closest('.cstm-product-card');
      var hasSizes = qcard && qcard.querySelector('.cstm-product-card__size-link');
      if (hasSizes) {
        var willOpen = !qcard.classList.contains('is-quickopen');
        document.querySelectorAll('.cstm-product-card.is-quickopen').forEach(function (c) { c.classList.remove('is-quickopen'); });
        if (willOpen) qcard.classList.add('is-quickopen');
        return;
      }
      /* single variant / no size options -> add straight away */
      var qv = qcard ? pickAddVariant(qcard) : null;
      if (!qv) return;
      if (!qv.available) {
        quickBtn.classList.add('is-error');
        setTimeout(function () { quickBtn.classList.remove('is-error'); }, 1600);
        return;
      }
      addVariant(qv.id, 1, quickBtn);
      return;
    }

    /* "Add to cart" (underlined button inside the panel) -> add selected colour + size */
    var addBtn = e.target.closest('.cstm-pc-add');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      if (addBtn.classList.contains('is-loading')) return;
      var acard = addBtn.closest('.cstm-product-card');
      var v = acard ? pickAddVariant(acard) : null;
      if (!v) return;
      if (!v.available) {
        addBtn.classList.add('is-error');
        setTimeout(function () { addBtn.classList.remove('is-error'); }, 1600);
        return;
      }
      addVariant(v.id, 1, addBtn);
      return;
    }

    /* tap outside -> close any open size panel */
    if (!e.target.closest('.cstm-product-card')) {
      document.querySelectorAll('.cstm-product-card.is-quickopen').forEach(function (c) { c.classList.remove('is-quickopen'); });
    }
  });

  /* ---------- cart drawer: change size of a line item ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-cstm-cart-size]');
    if (!sel) return;
    var newId = sel.value;
    var key = sel.getAttribute('data-key');
    var qty = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    if (!newId || !key) return;

    sel.disabled = true;
    var sections = drawerSections();

    // remove the old line, then add the newly-chosen size
    fetch(rootPath + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
      body: JSON.stringify({ id: key, quantity: 0 })
    })
      .then(function () {
        return fetch(rootPath + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({
            items: [{ id: Number(newId), quantity: qty }],
            sections: sections,
            sections_url: window.location.pathname
          })
        });
      })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state && !state.status) refreshDrawer(state);
        else sel.disabled = false;
      })
      .catch(function () { sel.disabled = false; });
  });

  /* ---------- product-card countdown ---------- */
  var countdowns = [];
  var cdTimer = null;

  function cdPad(n) { return n < 10 ? '0' + n : '' + n; }

  function tickCountdown(el) {
    var diff = el._cdEnd - Date.now();
    if (diff <= 0) {
      el._cdDone = true;
      el.setAttribute('hidden', 'hidden');
      return;
    }
    el.removeAttribute('hidden');
    var s = Math.floor(diff / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600);  s -= h * 3600;
    var m = Math.floor(s / 60);    s -= m * 60;
    if (el._cdD) el._cdD.textContent = cdPad(d);
    if (el._cdH) el._cdH.textContent = cdPad(h);
    if (el._cdM) el._cdM.textContent = cdPad(m);
    if (el._cdS) el._cdS.textContent = cdPad(s);
  }

  function tickAllCountdowns() {
    var alive = false;
    for (var i = 0; i < countdowns.length; i++) {
      var el = countdowns[i];
      if (el._cdDone) continue;
      tickCountdown(el);
      if (!el._cdDone) alive = true;
    }
    if (!alive && cdTimer) { clearInterval(cdTimer); cdTimer = null; }
  }

  function initCountdowns() {
    document.querySelectorAll('[data-pc-countdown]').forEach(function (el) {
      if (el.dataset.cdInit) return;
      el.dataset.cdInit = '1';
      var end = parseInt(el.getAttribute('data-end'), 10);
      if (!end) return;
      el._cdEnd = end * 1000;         // metafield outputs epoch seconds
      el._cdD = el.querySelector('[data-cd="d"]');
      el._cdH = el.querySelector('[data-cd="h"]');
      el._cdM = el.querySelector('[data-cd="m"]');
      el._cdS = el.querySelector('[data-cd="s"]');
      tickCountdown(el);              // paint immediately (also hides if already expired)
      countdowns.push(el);
    });
    if (countdowns.some(function (el) { return !el._cdDone; }) && !cdTimer) {
      cdTimer = setInterval(tickAllCountdowns, 1000);
    }
  }

  /* ---------- keep each card's price in sync with its selected variant ---------- */
  function initCardPrices() {
    document.querySelectorAll('.cstm-product-card').forEach(function (card) {
      updateCardPrice(card);
    });
  }

  /* ---------- init ---------- */
  function initCards() { initGalleries(); initCountdowns(); initCardPrices(); }
  if (document.readyState !== 'loading') initCards();
  else document.addEventListener('DOMContentLoaded', initCards);
  // cart drawer re-renders inject fresh markup -> re-init galleries there too
  document.addEventListener('cart:refresh', initCards);
  window.addEventListener('load', initCards);
})();
